import { formatBirthday, LONG_BDAY_FORMAT } from "../../../ana-toolbox/ana-toolbox.js";
import { isValid, differenceInYears } from "date-fns";
import { toBoolean } from "../helpers/toBoolean.js";
import "../../../../../constants/date/date.js";
import "../../../../../type/Appointment.js";
import "date-fns/fp/format";
import "date-fns/isValid";
import "date-fns/parse";
const toPost = (form) => {
  var _a;
  const birthday = formatBirthday(form.birthday || "");
  const holderBirthday = formatBirthday(form.holderBirthday || "");
  return {
    ...form,
    diseases: form.diseases || [],
    isPregnant: toBoolean(form.isPregnant),
    pregnantMonths: form.pregnantMonths && form.pregnantMonths > 0 ? Number(form.pregnantMonths) : void 0,
    signatureEncoded: (_a = form.signatureEncoded) == null ? void 0 : _a.replace("data:image/png;base64,", ""),
    birthday,
    holderBirthday,
    /* We need to remove the `company` and `dentalInsuranceCompany` fields as these fields holds the
     * name of the insurance company and is not accepted by the BE when the reference id is present.
     */
    insuranceCompany: form.insuranceCompanyId ? void 0 : form.insuranceCompany,
    dentalInsuranceCompany: form.dentalInsuranceCompanyId ? void 0 : form.dentalInsuranceCompany,
    hasFamilyInsurance: form.hasFamilyInsurance ?? false,
    /*
     * We have to invert the value here because the question is
     * "Do you and the family insurance holder have the same address?"
     * but the field is "livesOnDifferentAddress", which is the opposite.
     */
    livesOnDifferentAddress: form.livesOnDifferentAddress ?? false
  };
};
const isPatientUnderaged = (form) => {
  var _a;
  const trimmedValue = ((_a = form.birthday) == null ? void 0 : _a.trim()) || "";
  if (!(form == null ? void 0 : form.birthday))
    return false;
  try {
    const birthday = trimmedValue.length === LONG_BDAY_FORMAT.length ? new Date(formatBirthday(form == null ? void 0 : form.birthday)) : void 0;
    if (!isValid(birthday) || !birthday)
      return false;
    return differenceInYears(/* @__PURE__ */ new Date(), birthday) < 18;
  } catch (e) {
    return false;
  }
};
const hasFamilyInsuranceData = (form) => {
  return Boolean(form.holderFirstName) || Boolean(form.holderLastName) || Boolean(form.holderCity) || Boolean(form.holderStreet) || Boolean(form.holderZipcode) || Boolean(form.holderBirthday);
};
const hasLegalRepresentativeName = (form) => Boolean(form.contactPersonFirstName && form.contactPersonLastName);
const getSignerName = (form) => {
  const nameParts = hasLegalRepresentativeName(form) ? [form.contactPersonFirstName, form.contactPersonLastName] : [form.firstName, form.lastName];
  const validParts = nameParts.filter(Boolean);
  return validParts.length > 0 ? validParts.join(" ") : "";
};
export {
  getSignerName,
  hasFamilyInsuranceData,
  hasLegalRepresentativeName,
  isPatientUnderaged,
  toPost
};
